import React, { useEffect, useState } from "react";
import useFetch from "../../Hooks/useFetch";
import Api from "../../Hooks/Api";
import useSave from "../../Hooks/useSave";
import useDelete from "../../Hooks/useDelete";
import useUpdate from "../../Hooks/useUpdate";
import { Link } from "react-router-dom";
import Table from "./../../Components/Table";
import Modal from "react-awesome-modal";
import Select from "react-select";
import useValidateRole from "../../Hooks/useValidateRole";
import useFetchData from "../../Hooks/useFetchData";
import swal from "sweetalert";
const Users = (props) => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [cPassword, setcPassword] = useState("");
  const [organizationOptions, setOrganizations] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  const [view, setview] = useState(false);
  const [disableproceed, setdisableproceed] = useState(false);
  const [message, setmessage] = useState("");
  const [selectedFile, setselectedFile] = useState("");
  const [loaded, setloaded] = useState("");
  const [update, setUpdate] = useState(false);
  const [showRolesPoup, setshowRolesPoup] = useState(false);
  const [ViewApprovals, setviewApprovals] = useState(false);
  const [Roles, setRoles] = useState([]);
  const [InstitutionsApprovalWorkFlow, setInstitutionsApprovalWorkFlow] =
    useState([]);
  const [PageRole, setPageRole] = useState("Users");
  const Counties = useFetchData("api/counties/getAll");
  const SecurityGroups = useFetchData("api/securityGroups/getAll");
  const url = "api/registration/";
  const { state, FetchAll } = useFetch(url + "getAllUsers");

  const fetchOrgs = async () => {
    try {
      Api.get("/api/organizations")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setOrganizations(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchDepartments = async () => {
    try {
      Api.get("/api/departments")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setDepartmentOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchStaff = async () => {
    try {
      Api.get("/api/staff")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setStaffOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  useEffect(() => {
    FetchAll();
    fetchOrgs();
    fetchDepartments();
    fetchStaff();
  }, []);
  const handleSelect = (k, event) => {
    setInputs(k);
    Fetchroles(k.id);
  };
  const handleEdit = (k) => {
    setInputs(k);
    Fetchroles(k.id);
    setOpen(true);
    setUpdate(true);
    setview(false);
  };
  const handleView = (k) => {
    setInputs(k);
    Fetchroles(k.id);

    setview(true);
    setUpdate(false);
    setOpen(true);
  };
  const HandelDelete = (k) => {
    setInputs(k);
    if (k.id) {
      CallDeletehook();
    } else {
      alert("Select a record to delete");
    }
  };
  const MoreActions = (props) => {
    return (
      <span>
        <a
          class="btn btn-secondary btn-sm dropdown-toggle"
          href="#"
          role="button"
          id="dropdownMenuLink"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          More Actions&nbsp;&nbsp;
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        </a>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => handleView(props.selecteditem, e)}
          >
            View
          </a>

          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => handleEdit(props.selecteditem, e)}
          >
            Edit
          </a>

          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => HandelDelete(props.selecteditem, e)}
          >
            Delete
          </a>
        </div>
      </span>
    );
  };
  const ColumnData = [
    {
      label: "Id",
      field: "id",
      sort: "asc",
    },
    {
      label: "Name",
      field: "name",
      sort: "asc",
    },
    {
      label: "Username",
      field: "username",
      sort: "asc",
    },
    {
      label: "Mobile",
      field: "mobile",
      sort: "asc",
    },
    {
      label: "Email",
      field: "email",
      sort: "asc",
    },
    {
      label: "SecurityGroup",
      field: "securityGroup",
      sort: "asc",
    },
    {
      label: "Status",
      field: "status",
      sort: "asc",
    },
    {
      label: "FailedLogins",
      field: "failedLogins",
      sort: "asc",
    },
    {
      label: "Actions",
      field: "Actions",
      sort: "asc",
    },
  ];
  let Rowdata1 = [];
  const rows = state.data;
  if (rows.length > 0) {
    rows.forEach((k) => {
      const Rowdata = {
        Actions: <MoreActions selecteditem={k} />,
        // clickEvent: () => handleSelect(k),
        id: k.id,
        username: k.username,
        name: k.name,
        status: k.status === 1 ? "Active" : "Inactive",
        email: k.email,
        mobile: k.mobile,
        securityGroup: k.securityGroup.name,
        failedLogins: k.failedLogins,
      };
      Rowdata1.push(Rowdata);
    });
  }

  const Fetchroles = (id) => {
    Api.get("api/UserRoles/manageUserRoles?userId=" + id)
      .then(function (response) {
        setRoles(response.data);
      })
      .catch(function (error) {
        // handle error
      })
      .then(function () {
        // always executed
      });
  };

  const handleOpenModal = (event) => {
    //event.persist();
    setInputs({});
    setOpen(true);
  };
  const FetchApprovals = (id) => {
    Api.get("api/Users/UsersApprovalWorkFlow/" + id)
      .then(function (response) {
        setInstitutionsApprovalWorkFlow(response.data);
      })
      .catch(function (error) {})
      .then(function () {
        // always executed
      });
  };
  const handleViewApprovals = () => {
    if (inputs.id) {
      FetchApprovals(inputs.id);
      setviewApprovals(true);
    } else {
      alert("Select a record to veiw");
    }
  };

  const handleShowRolesPoup = () => {
    setOpen(false);
    setUpdate(false);
    setshowRolesPoup(true);
  };

  const closeRolesPoup = () => {
    setshowRolesPoup(false);
    setUpdate(false);
  };

  const handleSelectChange = (UserGroup, actionMeta) => {
    setInputs((inputs) => ({ ...inputs, [actionMeta.name]: UserGroup.value }));
  };

  const handlecPasswordInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    setcPassword(value);
  };
  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleCloseModal = () => {
    setOpen(false);
    setview(false);
    setUpdate(false);
    setshowRolesPoup(false);
    setviewApprovals(false);
  };
  const HandleSave = () => {
    useSave(url, inputs);
    setTimeout(() => {
      FetchAll();
    }, 5000);
    handleCloseModal();
  };

  const HandleUpdate = () => {
    //
    let data = {
      securityGroupId: inputs.securityGroupId,
      name: inputs.name,
      email: inputs.email,
      mobile: inputs.mobile,
      countyId: inputs.countyId,
      status: inputs.status,
      pfNumber: inputs.pfNumber,
      jobGroup: inputs.jobGroup,
      id: inputs.id,
    };
    useUpdate(url + "updateUser", data);
    setTimeout(() => {
      FetchAll();
    }, 5000);
    handleCloseModal();
  };
  const HandleSubmit = (event) => {
    event.preventDefault();

    if (inputs.securityGroupId == "" || inputs.securityGroupId == undefined) {
      swal("", "Select security group", "error");
      return;
    }

    if (update) {
      HandleUpdate();
    } else {
      if (cPassword !== inputs.password) {
        swal("", "Password do not match!", "error");
        return;
      }
      HandleSave();
    }
  };

  const CallDeletehook = () => {
    useDelete(url + "/" + inputs.id);
    FetchAll();
  };

  const RolesSelect = () => {
    const CategoryOptions = [];
    if (SecurityGroups.response) {
      let data = SecurityGroups.response.data;
      data.map((k, i) => {
        let col = {
          value: k.securityGroupId,
          label: k.name,
        };
        CategoryOptions.push(col);
      });
    }
    return (
      <Select
        name="securityGroupId"
        value={CategoryOptions.filter(
          (option) => option.value === inputs.securityGroupId,
        )}
        onChange={handleSelectChange}
        options={CategoryOptions}
      />
    );
  };
  const HandleRolesUpdate = (puturl, data = {}) => {
    useUpdate(puturl, data);
  };

  const handleCheckBoxChange = (Role, e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (name == "Create") {
      let data = {
        permissionId: Role.permissionId,
        userId: inputs.id,
        addRecord: value === true ? 1 : 0,
        exportRecord: Role.exportRecord,
        deleteRecord: Role.deleteRecord,
        viewRecord: Role.viewRecord,
        editRecord: Role.editRecord,
      };
      HandleRolesUpdate("api/UserRoles/create?menu=Create", data);
    } else if (name == "View") {
      let data = {
        permissionId: Role.permissionId,
        userId: inputs.id,
        addRecord: Role.addRecord,
        exportRecord: Role.exportRecord,
        deleteRecord: Role.deleteRecord,
        viewRecord: value === true ? 1 : 0,
        editRecord: Role.editRecord,
      };
      HandleRolesUpdate("api/UserRoles/create?menu=View", data);
    } else if (name == "Delete") {
      let data = {
        permissionId: Role.permissionId,
        userId: inputs.id,
        addRecord: Role.addRecord,
        exportRecord: Role.exportRecord,
        deleteRecord: value === true ? 1 : 0,
        viewRecord: Role.viewRecord,
        editRecord: Role.editRecord,
      };
      HandleRolesUpdate("api/UserRoles/create?menu=Delete", data);
    } else if (name == "Update") {
      let data = {
        permissionId: Role.permissionId,
        userId: inputs.id,
        addRecord: Role.addRecord,
        exportRecord: Role.exportRecord,
        deleteRecord: Role.deleteRecord,
        viewRecord: Role.viewRecord,
        editRecord: value === true ? 1 : 0,
      };
      HandleRolesUpdate("api/UserRoles/create?menu=Update", data);
    } else if (name == "Export") {
      let data = {
        permissionId: Role.permissionId,
        userId: inputs.id,
        addRecord: Role.addRecord,
        exportRecord: value === true ? 1 : 0,
        deleteRecord: Role.deleteRecord,
        viewRecord: Role.viewRecord,
        editRecord: Role.editRecord,
      };
      HandleRolesUpdate("api/UserRoles/create?menu=Export", data);
    }
  };

  const CountiesOptions = [];
  if (Counties.response) {
    let data = Counties.response.data;
    data.map((k, i) => {
      let col = {
        value: k.countyId,
        label: k.name,
      };
      CountiesOptions.push(col);
    });
  }

  const RolesPoup = () => {
    let tablestyle = {
      width: "60%",
    };

    let Menus = [];
    let Marketing = [];
    let Approval = [];
    let UserManagement = [];
    let Configurations = [];
    let MOUs = [];
    let Investments = [];
    let TourismSafety = [];
    let TourismActivities = [];
    let Reports = [];
    let TourismProducts = [];
    let VettingExpartriates = [];
    let Monitoring = [];
    let PolicyAndResearch = [];
    if (Roles.length > 0) {
      let MenusCategory = Roles.filter(
        (option) => option.permission.category === "Menus",
      );
      let PolicyAndResearchCategory = Roles.filter(
        (option) => option.permission.category === "PolicyAndResearch",
      );

      if (PolicyAndResearchCategory.length > 0) {
        PolicyAndResearch.push(PolicyAndResearchCategory);
      }
      let MonitoringCategory = Roles.filter(
        (option) => option.permission.category === "Monitoring",
      );
      let InvestmentsCategory = Roles.filter(
        (option) => option.permission.category === "Investments",
      );
      let VettingExpartriatesCategory = Roles.filter(
        (option) => option.permission.category === "VettingExpartriates",
      );
      let MarketingCategory = Roles.filter(
        (option) => option.permission.category === "Marketing",
      );
      let TourismSafetyCategory = Roles.filter(
        (option) => option.permission.category === "TourismSafety",
      );
      let TourismActivitiesCategory = Roles.filter(
        (option) => option.permission.category === "TourismActivities",
      );
      let UserManagementCategory = Roles.filter(
        (option) => option.permission.category === "User Management",
      );
      let TourismProductsCategory = Roles.filter(
        (option) => option.permission.category === "TourismProducts",
      );
      let ApprovalCategory = Roles.filter(
        (option) => option.permission.category === "Approval",
      );
      if (ApprovalCategory.length > 0) {
        Approval.push(ApprovalCategory);
      }
      let ConfigurationsCategory = Roles.filter(
        (option) => option.permission.category === "Configurations",
      );
      let MOUsCategory = Roles.filter(
        (option) => option.permission.category === "MOUs",
      );
      let ReportsCategory = Roles.filter(
        (option) => option.permission.category === "Reports",
      );
      if (ReportsCategory.length > 0) {
        Reports.push(ReportsCategory);
      }
      if (InvestmentsCategory.length > 0) {
        Investments.push(InvestmentsCategory);
      }
      if (MonitoringCategory.length > 0) {
        Monitoring.push(MonitoringCategory);
      }
      if (MarketingCategory.length > 0) {
        Marketing.push(MarketingCategory);
      }
      if (MOUsCategory.length > 0) {
        MOUs.push(MOUsCategory);
      }
      if (TourismProductsCategory.length > 0) {
        TourismProducts.push(TourismProductsCategory);
      }
      if (TourismActivitiesCategory.length > 0) {
        TourismActivities.push(TourismActivitiesCategory);
      }
      if (TourismSafetyCategory.length > 0) {
        TourismSafety.push(TourismSafetyCategory);
      }
      if (UserManagementCategory.length > 0) {
        UserManagement.push(UserManagementCategory);
      }
      if (VettingExpartriatesCategory.length > 0) {
        VettingExpartriates.push(VettingExpartriatesCategory);
      }
      if (MenusCategory.length > 0) {
        Menus.push(MenusCategory);
      }
      if (ConfigurationsCategory.length > 0) {
        Configurations.push(ConfigurationsCategory);
      }
    }

    return (
      <Modal visible={showRolesPoup} width="70%" height="90%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <a className="close" onClick={closeRolesPoup}>
            &times;
          </a>
          <div className="text-center">
            <b>{inputs.name}</b>{" "}
          </div>

          <form>
            <table className="table">
              <thead className="table-success">
                <th scope="col" style={tablestyle}>
                  Role
                </th>
                <th>Create</th>
                <th>View</th>
                <th>Delete</th>
                <th>Update</th>
                <th>Export</th>
              </thead>
              {Menus.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Menus
                  </h5>
                  {Menus[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {UserManagement.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    User Management
                  </h5>
                  {UserManagement[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {Approval.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Approval
                  </h5>
                  {Approval[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {TourismSafety.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Tourism Safety
                  </h5>
                  {TourismSafety[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {VettingExpartriates.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Vetting Expartriates
                  </h5>
                  {VettingExpartriates[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {Configurations.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Configurations
                  </h5>
                  {Configurations[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {Marketing.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Marketing
                  </h5>
                  {Marketing[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {Investments.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Investments
                  </h5>
                  {Investments[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {PolicyAndResearch.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Policy And Research
                  </h5>
                  {PolicyAndResearch[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {Monitoring.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Monitoring
                  </h5>
                  {Monitoring[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {MOUs.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    MOUs
                  </h5>
                  {MOUs[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}

              {TourismProducts.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Tourism Products
                  </h5>
                  {TourismProducts[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {TourismActivities.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Tourism Activities
                  </h5>
                  {TourismActivities[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {Reports.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Reports
                  </h5>
                  {Reports[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
            </table>

            <br />
            <div className="col-sm-12 ">
              <div className=" row">
                <div class="d-flex flex-row ">
                  <button
                    className="btn btn-primary p-2 float-right"
                    type="button"
                    onClick={closeRolesPoup}
                  >
                    Done
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-warning p-2"
                    type="button"
                    onClick={handleCloseModal}
                  >
                    Close
                  </button>
                </div>
              </div>
              <br />
            </div>
          </form>
        </div>
      </Modal>
    );
  };

  const ActionsBtn = () => {
    return (
      <div>
        {useValidateRole(PageRole, "Edit") ? (
          <button
            className="btn btn-primary p-2"
            type="button"
            onClick={handleEdit}
          >
            Update
          </button>
        ) : null}
        &nbsp;
        {useValidateRole("User Roles", "AddNew") ? (
          <button
            className="btn btn-info p-2"
            type="button"
            onClick={handleShowRolesPoup}
          >
            Roles
          </button>
        ) : null}
        &nbsp;
        {useValidateRole(PageRole, "Remove") ? (
          <button onClick={HandelDelete} className="btn btn-danger p-2">
            Delete
          </button>
        ) : null}
        &nbsp;
        <button
          className="btn btn-warning p-2"
          type="button"
          onClick={handleCloseModal}
        >
          Close
        </button>
      </div>
    );
  };
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">Users</li>
      </ol>
      <h1 class="page-header mb-3">Users</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div class="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            {useValidateRole(PageRole, "AddNew") ? (
              <button
                onClick={handleOpenModal}
                className="btn btn-primary p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                New user
              </button>
            ) : null}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={Rowdata1} columns={ColumnData} />
          </div>
        </div>
      </div>
      <Modal visible={ViewApprovals} width="80%" height="70%" effect="fadeInUp">
        <div style={{ overflowY: "auto", height: "100%" }}>
          <div class="col-xs-12 left-block">
            <br />
            <span className="font-weight-bold">Name:</span>&nbsp;&nbsp;
            <span className="font-weight-bold">{inputs.name}</span>
            <br />
            <span className="font-weight-bold">Is Active:</span>&nbsp;&nbsp;
            <span className="font-weight-bold">
              {" "}
              {inputs.status
                ? inputs.status.toString() == "true"
                  ? "Active"
                  : "In-active"
                : ""}
            </span>
            <br />
            <span className="font-weight-bold">Status:</span>&nbsp;&nbsp;
            <span className="font-weight-bold">
              {inputs.institutionStatus ? inputs.institutionStatus.name : "N/A"}
            </span>
            <br />
            <span className="font-weight-bold">Approval Status:</span>
            &nbsp;&nbsp;
            <span className="font-weight-bold">{inputs.approvalStatus}</span>
            <br />
          </div>
          <div className="wrapper wrapper-content animated fadeInRight">
            <div className="row">
              <div className="col-md-12">
                <table class="table table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Status</th>
                      <th scope="col">DateCreated</th>
                      <th scope="col">DateofApproval</th>
                      <th scope="col">Name</th>
                      <th scope="col">Mandatory</th>
                      <th scope="col">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {InstitutionsApprovalWorkFlow.map((k) => {
                      return (
                        <tr>
                          <td scope="row">{k.status}</td>
                          <th>{k.dateCreated}</th>
                          <th>{k.dateofApproval}</th>
                          <td>{k.name}</td>
                          <td>{k.isMandatory ? "Yes" : "No"}</td>
                          <td>{k.remarks}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", "justify-content": "flex-end" }}>
            <div class="d-flex flex-row">
              <button
                style={{ margin: "20px" }}
                className="btn btn-warning p-2"
                type="button"
                onClick={handleCloseModal}
              >
                Close{" "}
              </button>
            </div>
            <br />
          </div>
        </div>
      </Modal>
      <Modal visible={open} width="70%" height="85%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <a className="close" onClick={() => handleCloseModal()}>
            &times;
          </a>

          <div className="row">
            <div className="col-sm-5"></div>
          </div>
          <div
            className="row"
            style={{
              background: "",
            }}
          >
            <div class="col-xs-12 center-block text-center">
              {view ? (
                <h3 className="text-center font-weight-bold">{inputs.name}</h3>
              ) : (
                <h3 className="text-center font-weight-bold">System User</h3>
              )}
            </div>
          </div>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                {view ? (
                  <div>
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <td
                            className="font-weight-bold"
                            style={{ width: "20%" }}
                          >
                            Name:
                          </td>
                          <td>{inputs.name}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">UserName:</td>
                          <td>{inputs.username}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Email:</td>
                          <td>{inputs.email}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Mobile:</td>
                          <td>{inputs.mobile}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">PF Number:</td>
                          <td>{inputs.pfNumber}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Job Group:</td>
                          <td>{inputs.jobGroup}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Security Group:</td>
                          <td>{inputs.securityGroup.name}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">County:</td>
                          <td>{inputs.county.name}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Failed Logins:</td>
                          <td>{inputs.failedLogins}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div
                      style={{ display: "flex", "justify-content": "flex-end" }}
                    >
                      <ActionsBtn />
                    </div>
                  </div>
                ) : (
                  <form className="form-horizontal" onSubmit={HandleSubmit}>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            required
                            value={inputs.name || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Mobile
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="mobile"
                            required
                            value={inputs.mobile || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label htmlFor="pfNumber" className="fontWeight-bold">
                            PF Number
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="pfNumber"
                            required
                            value={inputs.pfNumber || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm">
                        <div className="form-group">
                          <label htmlFor="jobGroup" className="fontWeight-bold">
                            Job Group
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="jobGroup"
                            required
                            value={inputs.jobGroup || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className=" row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Email
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            required
                            value={inputs.email || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Security group
                          </label>
                          <RolesSelect />
                        </div>
                      </div>
                    </div>

                    <div className=" row">
                      <div className="col-sm-6">
                        <div className=" row">
                          <div className="col-sm-8">
                            <div className="form-group">
                              <label
                                htmlFor="Datereceived"
                                className="fontWeight-bold"
                              >
                                County
                              </label>
                              <Select
                                name="countyId"
                                value={CountiesOptions.filter(
                                  (option) => option.value === inputs.countyId,
                                )}
                                onChange={handleSelectChange}
                                options={CountiesOptions}
                              />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-check">
                              <br />
                              <br />
                              <input
                                type="checkbox"
                                onChange={handleInputChange}
                                className="form-check-input"
                                name="status"
                                defaultChecked={inputs.status}
                                id="exampleCheck1"
                              />
                              <label className="form-check-label">
                                Is Active
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        {update ? null : (
                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="Datereceived"
                                  className="fontWeight-bold"
                                >
                                  Password
                                </label>
                                <input
                                  type="password"
                                  className="form-control"
                                  name="password"
                                  required
                                  value={inputs.password || ""}
                                  onChange={handleInputChange}
                                  // defaultvalue={inputs.name}
                                />
                              </div>
                            </div>
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="Datereceived"
                                  className="fontWeight-bold"
                                >
                                  Confirm Password
                                </label>
                                <input
                                  type="password"
                                  className="form-control"
                                  name="cpassword"
                                  required
                                  value={cPassword}
                                  onChange={handlecPasswordInputChange}
                                  // defaultvalue={inputs.name}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Organization
                          </label>
                          <select
                            className="form-control"
                            name="orgId"
                            required
                            value={inputs.orgId || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Organization</option>
                            {organizationOptions &&
                              organizationOptions.map((types) => (
                                <option key={types.orgId} value={types.orgId}>
                                  {types.name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Department
                          </label>
                          <select
                            className="form-control"
                            name="deptId"
                            required
                            value={inputs.deptId || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Department</option>
                            {departmentOptions &&
                              departmentOptions
                                .filter((dept) => dept.orgId == inputs.orgId)
                                .map((dept) => (
                                  <option key={dept.deptId} value={dept.deptId}>
                                    {dept.name}
                                  </option>
                                ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Reports to
                          </label>
                          <select
                            className="form-control"
                            name="reportsTo"
                            required
                            value={inputs.reportsTo || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select staff</option>
                            {staffOptions &&
                              staffOptions.map((types) => (
                                <option
                                  key={types.staffId}
                                  value={types.staffId}
                                >
                                  {types.fullName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div
                        style={{
                          display: "flex",
                          "justify-content": "flex-end",
                        }}
                      >
                        <div class="d-flex flex-row">
                          {update ? (
                            <button
                              className="btn btn-primary p-2"
                              type="submit"
                              disabled={disableproceed}
                            >
                              Update
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary p-2"
                              type="submit"
                              disabled={disableproceed}
                            >
                              Submit
                            </button>
                          )}
                          &nbsp;
                          <button
                            className="btn btn-warning p-2"
                            type="button"
                            onClick={handleCloseModal}
                          >
                            Close
                          </button>
                        </div>
                        <br />
                      </div>
                      <br />
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <RolesPoup />
    </div>
  );
};
export default Users;
